import { defineComponent as l, useModel as m, watch as u, onMounted as p, openBlock as f, createBlock as _, unref as t, withCtx as d, createVNode as v } from "vue";
import { FontAwesomeIcon as C } from "@fortawesome/vue-fontawesome";
import { faWifiExclamation as y } from "@fortawesome/pro-regular-svg-icons";
import I, { useToast as M } from "@ui-kit/components/toast";
import { useOnline as g } from "@vueuse/core";
import { useI18n as h } from "vue-i18n";
const w = /* @__PURE__ */ l({
  __name: "InternetConnectionMonitor",
  props: {
    online: { type: Boolean, default: !0 },
    onlineModifiers: {}
  },
  emits: ["update:online"],
  setup(n) {
    const e = g(), i = M(), { t: a } = h(), r = m(n, "online"), c = () => i.add({
      group: "internet-connection",
      closable: !1,
      severity: "warn",
      summary: a("message")
    });
    return u(e, (o) => {
      r.value = o, o ? i.removeGroup("internet-connection") : c();
    }), p(() => {
      e.value || c(), r.value = e.value;
    }), (o, x) => (f(), _(t(I), {
      group: "internet-connection",
      position: "top-center"
    }, {
      icon: d(() => [
        v(t(C), {
          icon: t(y),
          class: "place-self-center"
        }, null, 8, ["icon"])
      ]),
      _: 1
    }));
  }
});
function s(n) {
  const e = n;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "en",
    resource: {
      message: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "No Internet Connection" } }
    }
  });
}
typeof s == "function" && s(w);
export {
  w as InternetConnectionMonitor
};
//# sourceMappingURL=index.es.js.map
